import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../../lib/api-client';

export const useGetCreditMemos = () => {
    const { data, isLoading } = useQuery({
        queryKey: ['credit-memos'],
        queryFn: async () => await apiClient.get(`purchase-order/credit-memos`) as []
    });

    return {
        data: data || [],
        isLoading: isLoading
    };
};
